import TrackWrapper from '@/common/TrackWrapper';
import BreadcrumbBar from '@/new-cars/BreadcrumbBar';
import { TileGrid } from '@/new-cars/new-cars.styles';
import ParentModelCard from '@/new-cars/ParentModelSection/ParentModelCard';
import { SECTION_VIEW_THRESHOLD } from '~/constants/new-cars/sectionViewThreshold';
import type { MakeConfigurationResponse } from '~/contracts/new-cars';

const viewEvent = {
  customAttributes: {
    action: 'viewed',
    level: 'Parent Model',
    section: 'Parent Model'
  },
  eventName: 'New Cars'
};

type OwnProps = {
  make: string;
  parentModels: MakeConfigurationResponse;
};

export default function ParentModelSection({ make, parentModels }: OwnProps) {
  return (
    <TrackWrapper
      aria-labelledby="parent-model-section-heading"
      element="section"
      event={viewEvent}
      threshold={SECTION_VIEW_THRESHOLD}
      trackOnce
      className="flex flex-col gap-2xl px-2xl py-3xl"
    >
      <BreadcrumbBar make={make} />
      <h2
        className="text-text-strong t-heading-xl"
        id="parent-model-section-heading"
      >
        Select your {make}
      </h2>
      <TileGrid>
        {parentModels.results.map(parentModel => (
          <ParentModelCard
            key={parentModel.title}
            make={make}
            parentModel={parentModel}
          />
        ))}
      </TileGrid>
    </TrackWrapper>
  );
}
